import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCorsica = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_1948)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
				fill: "#FCFCFC"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.1783 10.1641C16.1783 7.62605 14.1209 5.56866 11.5829 5.56866C9.71008 5.56866 8.10006 6.68945 7.38419 8.29651L6.81742 10.3513L7.33914 10.873L6.29565 12.96L7.33914 13.4817L6.81742 14.0034V14.5251L7.33914 15.0468V16.0903L7.86086 16.612L9.42606 16.0903C9.42606 16.0903 9.42606 16.612 9.94778 17.1338C10.4695 17.6555 10.9913 18.699 10.9913 18.699C10.9913 18.699 12.5565 19.2208 13.6 17.6556C14.6435 16.0904 15.687 15.5686 15.687 15.5686L14.6812 13.557C15.601 12.7169 16.1783 11.5081 16.1783 10.1641Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.5527 11.9213C18.6729 11.5637 19.026 7.4122 19.026 7.4122H16.1043C17.6173 11.0644 16.0337 11.31 16.0337 11.31C15.8191 11.1504 8.14108 7.51312 7.8977 7.42064C7.83906 7.49911 7.6232 7.70522 7.3608 8.34694C7.09834 8.98865 7.03394 9.56597 7.03394 9.56597C7.15684 9.64608 15.3109 12.4933 15.5264 12.517C15.9542 12.7967 16.4805 13.633 16.1863 16.1126L18.9985 15.32C18.9986 15.32 18.0442 12.7811 16.5527 11.9213Z",
				fill: "#ACABB1"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_1948",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgCorsica;
